import { useEffect } from 'react'

import { addLocationPin, getLocationPin } from '@/map'

import type { LocationEditorFieldConfig, LocationEditorFieldValue } from '../types'

export function useInitializeFormFieldLocationPin(
  options: LocationEditorFieldConfig,
  location: LocationEditorFieldValue,
) {
  const {
    pinId,
    pinHidden,
    pinType,
    pinInfo,
    disabled,
    snapToRoad,
    pinRadius = 0,
    connectedPlaceId,
  } = options

  // create the target Location Pin if not already available
  useEffect(() => {
    if (disabled) return

    const pin = getLocationPin(pinId)

    if (!location) {
      throw new Error(
        `Trying to connect a LocationEditor Field to the Map without a source form value`,
      )
    }

    if (!pin) {
      addLocationPin(
        pinId,
        { ...location.latLng },
        {
          snapToRoad,
          radius: pinRadius,
          location: { ...location },
          type: connectedPlaceId ? 'depot' : pinType,
        },
        pinInfo,
        pinHidden,
      )
    }
  }, [
    pinId,
    pinHidden,
    pinType,
    pinInfo,
    pinRadius,
    snapToRoad,
    location,
    disabled,
    connectedPlaceId,
  ])
}
